import {
  addContentTypesToQuery,
  addMetadataToQuery,
  relativeQuery,
  withQuerystringResults,
} from 'govbr.frontend.policy/helpers';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { CardsBodyBase } from '../Cards/CardsBody';

const metadata_fields = [
  'titulo_card',
  'descricao_card',
  'icone_card',
  'image_scales',
  'alt_card',
  'remoteUrl',
];

const contentTypes = ['Document', 'Link', 'Area'];

const addContentTypes = (query) => {
  return addContentTypesToQuery(query, contentTypes);
};

const addMetadata = (query) => {
  return addMetadataToQuery(query, metadata_fields);
};

const ListingCardsBody = withQuerystringResults(
  CardsBodyBase,
  compose(addContentTypes, addMetadata, relativeQuery),
  metadata_fields,
);

ListingCardsBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default ListingCardsBody;
